import { isPlatform } from '@ionic/vue';

export const isTablet = isPlatform('tablet');
export const isPhablet = isPlatform('phablet');
